var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fill-height", staticStyle: { position: "relative" } },
    [
      _vm.loading && _vm.products.length === 0
        ? [
            _vm._t("loading", function () {
              return [
                _c("v-progress-circular", {
                  staticStyle: {
                    position: "fixed",
                    top: "50vh",
                    left: "50vw",
                    transform: "translate(-50%, -50%)",
                  },
                  attrs: {
                    indeterminate: "",
                    size: "60",
                    width: "3",
                    color: "dark",
                  },
                }),
              ]
            }),
          ]
        : _vm.products.length === 0
        ? [_vm._t("empty")]
        : [
            _c(
              "v-row",
              {
                staticClass: "px-1",
                class: {
                  "flex-nowrap overflow-x-auto hide-scrollbar": _vm.row,
                },
                attrs: { "no-gutters": "" },
              },
              _vm._l(_vm.products, function (product) {
                return _c(
                  "v-col",
                  _vm._b(
                    { key: product.id, staticClass: "pa-1" },
                    "v-col",
                    _vm.sizes,
                    false
                  ),
                  [
                    _vm._t(
                      "default",
                      function () {
                        return [
                          _c("product-card", { attrs: { product: product } }),
                        ]
                      },
                      { product: product }
                    ),
                  ],
                  2
                )
              }),
              1
            ),
            _vm.$slots.pagination
              ? _c(
                  "v-row",
                  {
                    staticClass: "mt-4 px-4 px-sm-12",
                    staticStyle: { "margin-bottom": "72px" },
                    attrs: { "no-gutters": "" },
                  },
                  [_c("v-col", [_vm._t("pagination")], 2)],
                  1
                )
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }